import UriTemplate from 'uri-templates';
import {halClient} from "../hal";
import {BBModel} from "../bb_model";
import {context} from "../constants/context";

const product = {
        getProduct(prms) {
            let href, uri;
            return new Promise((resolve, reject) => {

                if (prms.id) {
                    href = context.apiUrl + `/api/${context.apiVersion}/{company_id}/products/{id}`;
                    uri = new UriTemplate(href).fillFromObject({company_id: prms.company_id, id: prms.product_id});
                } else if (prms.sku) {
                    href = context.apiUrl + `/api/${context.apiVersion}/{company_id}/products/find_by_sku/{sku}`;
                    uri = new UriTemplate(href).fillFromObject({company_id: prms.company_id, sku: prms.sku});
                } else {
                    console.warn('id or sku is required');
                    reject();
                }

                halClient.$get(uri, {}).then(product => resolve(new BBModel.Product((product)))
                    , (err) => {
                        return reject(err);
                    }
                );

            });
        },


        query(company) {
            return new Promise((resolve, reject) => {
                if (!company.$has('products')) {
                    reject('No products found');
                } else {
                    company.$get('products').then((resource) => {
                            return resource.$get('products').then((items) => {
                                    const resources = [];
                                    for (const i of Array.from(items)) {
                                        resources.push(new BBModel.Product(i));
                                    }
                                    return resolve(resources);
                                }
                            );
                        }
                        , (err) => {
                            return reject(err);
                        }
                    );
                }
            });
        }
    };

export {
    product
}

